/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Pos_Order_Vat_IncludedInputs */

const vi_pos_order_vat_included = /** @type {(inputs: Pos_Order_Vat_IncludedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã gồm VAT ${i?.percent}%:`)
};

/**

* @param {Pos_Order_Vat_IncludedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_order_vat_included = /** @type {((inputs: Pos_Order_Vat_IncludedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Order_Vat_IncludedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_order_vat_included(inputs)
});